// @ts-nocheck

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { API_BASE_URL } from "../utils/api";

export const Route = createFileRoute("/auth")({
  component: RouteComponent,
});

function RouteComponent() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [authDetails, setAuthDetails] = useState([]);
  const authCheck = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    fetch(
      `${API_BASE_URL}/auth?username=${username}&password=${password}`,
    )
      .then((response) => response.json())
      .then((result) => setAuthDetails(result[0]))
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    if (authDetails) {
      if (authDetails.length !== 0) {
        localStorage.setItem("auth", JSON.stringify(authDetails));
        if (localStorage.getItem("routeBeforeAuth")) {
          navigate({
            to: `${localStorage.getItem("routeBeforeAuth")}`,
            reloadDocument: true,
          });
        } else {
          navigate({ to: "/" });
        }
      }
    }
  }, [authDetails, localStorage]);

  return (
    <form onSubmit={authCheck}>
      <div className="flex flex-col gap-4 rounded-box bg-base-200 p-6 h-full">
        <h1 className="text-3xl font-bold self-center">Log in</h1>
        <pre className="self-center">
          Version: {import.meta.env.VITE_REACT_APP_VERSION}
        </pre>

        <div className="divider" />

        {/* <label className="form-control">
          <div className="label">
            <span className="label-text">Username</span>
          </div>
          <input
            className="input input-bordered w-full"
            value={username}
            required
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>
        <label className="form-control">
          <div className="label">
            <span className="label-text">Password</span>
          </div>
          <input
            type="password"
            required
            className="input input-bordered w-full"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <button className="btn btn-primary" type="submit">
          Log in
        </button> */}
      </div>
    </form>
  );
}
